import { render, staticRenderFns } from "./CampusChooser.vue?vue&type=template&id=94824c4a"
import script from "./CampusChooser.vue?vue&type=script&lang=js"
export * from "./CampusChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports